import React from "react";
import "./WorkingPlan.css";

import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

export default function WorkingPlan() {
  return (
    <div className="WorkingPlan-Body">
      <div className="WorkingPlan-Box">
        <p className="WorkingPlan-Text1">|| Pricing Plans</p>
        <p className="WorkingPlan-Text2">Let's Start Working</p>
        <div className="WorkingPlan-Div">
          <div className="WorkingPlan-Cart-Body">
            <p className="WorkingPlan-Cart-Text1">Hourly</p>
            <div className="WorkingPlan-Cart-Line" />
            <div className="WorkingPlan-Cart-Box">
              <p className="WorkingPlan-Cart-Text2">$15</p>
              <p className="WorkingPlan-Cart-Text3">/ Per Hour</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">One time contract</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">Flexible Contract</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">Source Files</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CloseOutlined className="WorkingPlan-Cart-Icon2" />
              <p className="WorkingPlan-Cart-Text4">Support</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CloseOutlined className="WorkingPlan-Cart-Icon2" />
              <p className="WorkingPlan-Cart-Text4">Updates</p>
            </div>
            <div style={{ height: "30px" }} />
          </div>

          <div className="WorkingPlan-Cart-Body">
            <p className="WorkingPlan-Cart-Text1">Project Basis</p>
            <div className="WorkingPlan-Cart-Line" />
            <div className="WorkingPlan-Cart-Box">
              <p className="WorkingPlan-Cart-Text2">$13</p>
              <p className="WorkingPlan-Cart-Text3">/ Per Hour</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">One time contract</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">Flexible Contract</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">Source Files</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">Support</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CloseOutlined className="WorkingPlan-Cart-Icon2" />
              <p className="WorkingPlan-Cart-Text4">Updates</p>
            </div>
            <div style={{ height: "30px" }} />
          </div>

          <div className="WorkingPlan-Cart-Body">
            <p className="WorkingPlan-Cart-Text1">Monthly</p>
            <div className="WorkingPlan-Cart-Line" />
            <div className="WorkingPlan-Cart-Box">
              <p className="WorkingPlan-Cart-Text2">$10</p>
              <p className="WorkingPlan-Cart-Text3">/ Per Hour</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">One time contract</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">Flexible Contract</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">Source Files</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">Support</p>
            </div>
            <div className="WorkingPlan-Cart-Div">
              <CheckOutlined className="WorkingPlan-Cart-Icon1" />
              <p className="WorkingPlan-Cart-Text4">Updates</p>
            </div>
            <div style={{ height: "30px" }} />
          </div>
        </div>
      </div>
    </div>
  );
}
